import React, { useEffect } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { Field } from 'formik';
import { Select } from '@material-ui/core';
import RxOrderContainer from '../../containers/RxOrder';

interface Props {
  meganetOptionItemId: number,
  leftMeganetLensMasterId: number,
  rightMeganetLensMasterId: number,
  meganetOptionMasterId: number,
  isRequired: boolean,
  onChange: (meganetOptionItemId: number) => void,
}

export default ((props) => {
  const rxOrderContainer = RxOrderContainer.useContainer();

  const defaultOptionItemId = rxOrderContainer.getRightOptionItemByOptionMasterId(props.rightMeganetLensMasterId, props.meganetOptionMasterId)[0].meganetOptionItemId;
  const meganetOptionItemId = (props.isRequired && props.meganetOptionItemId === -1) ? defaultOptionItemId : (props.meganetOptionItemId || defaultOptionItemId);

  useEffect(() => {
    if (props.meganetOptionItemId === undefined || (props.isRequired && props.meganetOptionItemId === -1)) {
      props.onChange(meganetOptionItemId);
    }
  }, []);

  return (
    <Field style={{ fontSize: 13, }} required fullWidth name='option' label='Option' id='option' value={meganetOptionItemId} onChange={(event: React.ChangeEvent<HTMLSelectElement>) => props.onChange(Number(event.target.value))} component={Select} >
      {props.isRequired ? <></> : <MenuItem style={{ height: 30, }} key={-1} value={-1}>--</MenuItem>}
      // TODO Add TextField
      {props.meganetOptionMasterId !== 0
        ?
        rxOrderContainer.getRightOptionItemByOptionMasterId(props.rightMeganetLensMasterId, props.meganetOptionMasterId).map(optionItem => (
          <MenuItem key={optionItem.meganetOptionItemId} value={optionItem.meganetOptionItemId}>{optionItem.optionItemName}</MenuItem>
        ))
        :
        <></>
      }
    </Field >
  );
}) as React.FC<Props>;
